import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const KeywordDensityHistogram = ({ data }) => {
  const flattenedData = data.flat();
  const top20Data = flattenedData
    .sort((a, b) => b.weight - a.weight)
    .slice(0, 20);

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart
        data={top20Data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 80, // Increased bottom margin for x-axis labels
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis 
          dataKey="keyword" 
          tick={{ angle: -45, textAnchor: 'end' }} // Rotating labels for better fit
          interval={0} // Ensures all labels are rendered
        />
        <YAxis label={{ value: "Weight", angle: -90, position: "insideLeft" }} />
        <Tooltip />
        <Bar
          dataKey="weight"
          fill="rgb(255, 77, 112)" // Static color for all bars
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default KeywordDensityHistogram;
